import { Injectable } from '@angular/core';
import {
	CachePolicy,
	CachePolicyEntity,
	UrlService,
} from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { DcBaseRequester } from '../core/dc-base.requester';
import { IRankingResponse } from './ranking.model';

@Injectable({
	providedIn: 'root',
})
export class RankingRequester extends DcBaseRequester<IRankingResponse> {
	protected resource;
	protected elementsListUrl;
	protected singleElementUrl;

	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('RANKING');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
	}

	public getRankingList(
		useCache: boolean
	): Observable<ReadonlyArray<IRankingResponse>> {
		const resourceUrl = this.generateResourceUrl('RANKINGS_DETAILED');

		const url = this.urlService.generateUrl(
			resourceUrl,
			{},
			{
				project: this.projectId,
				details: true,
			}
		);
		const cachePolicy = useCache
			? CachePolicyEntity.build({
					policy: CachePolicy.NetworkAndCache,
					maxAgeInSeconds: 60,
					isCacheable: true,
			  })
			: CachePolicyEntity.build({
					policy: CachePolicy.NetworkOnly,
					maxAgeInSeconds: 0,
					isCacheable: false,
			  });
		return this.get<Array<IRankingResponse>>(url, cachePolicy);
	}

	public deleteRanking(rankingId: number): Observable<void> {
		const resourceUrl = this.generateResourceUrl('RANKING_BY_ID');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{
				rankingId,
			},
			{
				project: this.projectId,
			}
		);
		return this.http.delete<void>(url);
	}

	public duplicateRanking(rankingId: number): Observable<void> {
		const resourceUrl = this.generateResourceUrl('DUPLICATE_RANKING');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{
				rankingId,
			},
			{
				project: this.projectId,
			}
		);
		return this.http.get<void>(url);
	}

	public enableRanking(rankingId: number): Observable<void> {
		const resourceUrl = this.generateResourceUrl('RANKING_ENABLE');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{
				rankingId,
			},
			{
				project: this.projectId,
			}
		);
		return this.http.get<void>(url);
	}

	public disableRanking(rankingId: number): Observable<void> {
		const resourceUrl = this.generateResourceUrl('RANKING_DISABLE');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{
				rankingId,
			},
			{
				project: this.projectId,
			}
		);
		return this.http.get<void>(url);
	}
}
